module.exports = __webpack_public_path__ + "static/media/decent-work.093b7e9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/decent-work.png
// module id = 574
// module chunks = 0